import { Suspense } from 'react'
import { RouterProvider, createBrowserRouter } from 'react-router-dom'
import { appRoutes } from '@/config/routes'
import { AppProvider } from '@/contexts/AppContext'
import './App.css'

const router = createBrowserRouter(appRoutes)

function App() {
  return (
    <AppProvider>
      <Suspense fallback={<div className="app-loader">Загрузка...</div>}>
        <RouterProvider router={router} />
      </Suspense>
    </AppProvider>
  )
}

export default App
